"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERP_CONNECTION_SOURCES = exports.ERP_CONNECTION_PDP_ENVIRONMENTS = void 0;
var ERP_CONNECTION_SOURCES = exports.ERP_CONNECTION_SOURCES = ['PDP', 'NONE'];
var ERP_CONNECTION_PDP_ENVIRONMENTS = exports.ERP_CONNECTION_PDP_ENVIRONMENTS = ['DEVELOP', 'STAGING', 'SANDBOX', 'PRODUCTION', 'BACKEND'];